module.exports = __webpack_public_path__ + "static/media/individual-over.6110c96a.svg";